/**
 * Executa `processar` em todos os itens, no máximo `tamanhoDoLote` de cada vez: o lote seguinte só
 * começa quando o anterior termina inteiro. Serve para não disparar de uma vez uma requisição por item
 * de uma lista grande.
 *
 * O resultado sai na ordem dos itens. Se um item falhar, a promessa é rejeitada com o erro dele e os
 * lotes seguintes não são executados.
 */
export default async function processarEmLotes<T, R>(
	itens: T[],
	tamanhoDoLote: number,
	processar: (item: T) => Promise<R>,
): Promise<R[]> {
	const tamanho = Math.max(1, Math.floor(tamanhoDoLote) || 1)
	const resultados: R[] = []

	for (let inicio = 0; inicio < itens.length; inicio += tamanho) {
		// eslint-disable-next-line no-await-in-loop
		const resultadosDoLote = await Promise.all(itens.slice(inicio, inicio + tamanho).map(item => processar(item)))
		resultados.push(...resultadosDoLote)
	}

	return resultados
}
